import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    maxHeight: { type: Number, default: 240 }
  }

  connect() {
    this.resize()
  }

  resize() {
    this.element.style.height = "auto"

    const contentHeight = this.element.scrollHeight
    const visibleHeight = Math.min(contentHeight, this.maxHeightValue)

    this.element.style.height = `${visibleHeight}px`
    this.element.style.overflowY = contentHeight > this.maxHeightValue ? "auto" : "hidden"
  }
}
